"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf4 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Layout = _interopRequireDefault(require("../Layout"));

require("./page.sass");

var Page =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Page, _Component);

  function Page() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Page);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf4.default)(Page)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleSetHeight", function (height) {
      _this.setState({
        animated: !!_this.state.contentStyle,
        contentStyle: {
          marginBottom: "-".concat(height, "px"),
          transform: "translate3d(0, ".concat(height, "px, 0)"),
          paddingBottom: "".concat(height * 2, "px")
        }
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Page, [{
    key: "renderTop",
    value: function renderTop() {
      var Top = this.props.Top;
      return Top && _react.default.createElement(Top, this.props);
    }
  }, {
    key: "renderBar",
    value: function renderBar() {
      var Bar = this.props.Bar;
      return Bar && _react.default.createElement(Bar, this.props);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var Content = this.props.Content;
      return Content && _react.default.createElement(Content, this.props);
    }
  }, {
    key: "renderInteractiveBar",
    value: function renderInteractiveBar() {
      var InteractiveBar = this.props.InteractiveBar;
      return InteractiveBar && _react.default.createElement(InteractiveBar, null);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_Layout.default, {
        vertical: true,
        className: "page"
      }, _react.default.createElement("div", {
        className: "page-top"
      }, this.renderTop(), this.renderBar()), _react.default.createElement(InteractiveBarContainer, {
        onSetHeight: this.handleSetHeight
      }, this.renderInteractiveBar()), _react.default.createElement("div", {
        className: (0, _classnames.default)('page-content', {
          'page-content--animated': this.state.animated
        }),
        style: this.state.contentStyle
      }, this.renderContent()));
    }
  }]);
  return Page;
}(_react.Component);

exports.default = Page;

var InteractiveBarContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(InteractiveBarContainer, _PureComponent);

  function InteractiveBarContainer() {
    var _getPrototypeOf3;

    var _this2;

    (0, _classCallCheck2.default)(this, InteractiveBarContainer);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf3 = (0, _getPrototypeOf4.default)(InteractiveBarContainer)).call.apply(_getPrototypeOf3, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "state", {
      active: {},
      children: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "setHeight", function () {
      if (!_this2.element) {
        return;
      }

      var height = _this2.element.offsetHeight;

      if (_this2.height !== height) {
        _this2.props.onSetHeight(height);

        _this2.height = height;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "handleRef", function (element) {
      _this2.element = element;

      _this2.setHeight();
    });
    return _this2;
  }

  (0, _createClass2.default)(InteractiveBarContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      requestAnimationFrame(this.setHeight);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "page-interactiveBar-container"
      }, _react.default.createElement("div", {
        ref: this.handleRef,
        className: "page-interactiveBar-items"
      }, this.props.children));
    }
  }]);
  return InteractiveBarContainer;
}(_react.PureComponent);